<template>
  <div class="m-onlineofficial" :class="[$route.params.type=='fx'?'m-onlineofficial-padding':'',pageSource=='sx'?'m-onlineofficial-nopadding':'']">
    <div class="m-header-wrap" v-if="pageSource !== 'sx'">
      <div v-if="$route.params.type !== 'fx'" class="phone-number">
        <img src="../../assets/images/mImg/icon_phone.png" alt="">
        <span>400-061-6167</span>
      </div>
      <div class="login-wrap">
        <img @click="changePages('index')" class="m-logo" src="../../assets/images/logo.png" alt="">
        <div @click="goLogin" class="login-btn">登录</div>
      </div>
      <MHeader v-if="showHeader" @changePages="changePages"></MHeader>
    </div>
    <MHome @changePages="changePages" v-if="$route.params.type === 'index' || !$route.params.type"></MHome>
    <MSolution v-if="$route.params.type === 'solution'"></MSolution>
    <MCase v-if="$route.params.type === 'case'"></MCase>
    <MSupport v-if="$route.params.type === 'support'"></MSupport>
    <MAbout v-if="$route.params.type === 'about'"></MAbout>
    <MFenxiao v-if="$route.params.type === 'fx'"></MFenxiao>
    <MFooter v-if="pageSource !== 'sx'"></MFooter>
  </div>
</template>
<script>
import MHeader from "./components/MHeader.vue";
import MHome from './MHome.vue'
import MSolution from './MSolution.vue'
import MCase from './MCase.vue'
import MSupport from './MSupport.vue'
import MAbout from './MAbout.vue'
import MFooter from './components/MFooter.vue'
import MFenxiao from './MFenxiao.vue';
export default {
  data() {
    return {
      pageSource: this.$route.query.type, // 页面来源 xs数校免费区
      showHeader: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll)
    })
  },
  methods: {
    changePages(type) {
      if (type != this.$route.params.type) {
        this.$router.push({path: '/mett/'+ type})
        document.documentElement.scrollTop = document.body.scrollTop = 0
      }
    },
    goLogin() {
      let url = this.$router.resolve({
        path: '/mlogin'
      })
      window.open(url.href, '_blank')
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (this.$route.params.type === 'index' || !this.$route.params.type) {
        if (scrollTop >= document.querySelector('.m-home-nav').offsetTop) {
          this.showHeader = true
        } else {
          this.showHeader = false
        }
      } else if (this.$route.params.type === 'fx') {
        this.showHeader = false
      } else {
        if (scrollTop >= document.querySelector('.m-page-banner').offsetTop) {
          this.showHeader = true
        } else {
          this.showHeader = false
        }
      }
    }
  },
  components: {
    MHeader,
    MHome,
    MSolution,
    MCase,
    MSupport,
    MAbout,
    MFooter,
    MFenxiao
  }
};
</script>
<style lang="scss" scoped>
.m-onlineofficial {
  min-height: 100vh;
  width: 100%;
  background: #F7F9F9;
  padding-top: 1.6rem;
  .m-header-wrap {
    width: 100%;
    font-weight: 400;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    .phone-number {
      width: 100%;
      height: .62rem;
      background: #DCDDDD;
      font-size: .26rem;
      color: #595757;
      line-height: .64rem;
      text-align: right;
      padding-right: .58rem;
      img {
        width: .34rem;
        height: .32rem;
        vertical-align: middle;
        margin-right: .12rem;
      }
    }
    .login-wrap {
      width: 100%;
      height: .98rem;
      padding: 0 .58rem 0 .5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FFFFFF;
      box-shadow: 0px .03rem .1rem 0px rgba(128, 127, 127, 0.39);
      position: relative;
      z-index: 1;
      .m-logo {
        width: 2.88rem;
        height: .68rem;
      }
      .login-btn {
        width: .92rem;
        height: .4rem;
        text-align: center;
        line-height: .4rem;
        font-size: .27rem;
        color: #FFFFFF;
        background: #217CFE;
        border-radius: .2rem;
      }
    }
  }
}
.m-onlineofficial-padding {
  padding-top: .98rem;
}
.m-onlineofficial-nopadding {
  padding-top: 0;
}
</style>
